export { default } from './PromotionalMaterialsFromUserList';



// WEBPACK FOOTER //
// ./src/components/PromotionalMaterials/PromotionalMaterialsListFromUser/index.js